import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import { RECOMMEND_REVIEW_PAGE_NAME } from '../../../constants/service/app/recommendReviewConstants';
import RecommendReviewDetailContainer from '../../../containers/recommend/review/RecommendReviewDetailContainer';

const RecommendReviewDetail = () => {
  return (
    <PageTemplate pageName={RECOMMEND_REVIEW_PAGE_NAME.RECOMMEND_REVIEW_DETAIL}>
      <RecommendReviewDetailContainer />
    </PageTemplate>
  );
};

export default RecommendReviewDetail;
